
import { Component, Prop, Vue } from "nuxt-property-decorator";
import DataDisplayLayout from "./DataDisplayLayout.vue";

@Component({
  components: {
    DataDisplayLayout,
  },
})
export default class HeatingOilDataDisplay extends Vue {
  @Prop({ default: "default" }) margin: "default" | "none";

  get hasChartControls() {
    return !!this.$slots["chart-controls"];
  }
}
